import { render, staticRenderFns } from "./quota.vue?vue&type=template&id=8c0b5d94&"
import script from "./quota.vue?vue&type=script&lang=js&"
export * from "./quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports